export default __webpack_public_path__ + "static/media/addPeople.62b76da2.png";